import { Button, Group, Skeleton, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { IconRefresh } from "@tabler/icons-react";
import dayjs from "dayjs";
import { consoleApi } from "../../api/console";
import { PageHeader } from "../../components/common/PageHeader";
import { QueryError } from "../../components/common/QueryError";
import { InboxList } from "../../components/console/InboxList";
import { useI18n } from "../../i18n/context";

/** Everything waiting on a human, most urgent first, scoped to the role. */
export function InboxPage() {
  const { t } = useI18n();
  const inbox = useQuery({ queryKey: ["ops-inbox"], queryFn: consoleApi.inbox, refetchInterval: 60_000 });

  return (
    <>
      <PageHeader
        title={t("inbox.title")}
        subtitle={t("inbox.subtitle")}
        actions={
          <Group gap="sm">
            {inbox.data && (
              <Text size="xs" c="dimmed">
                {t("common.updated", { time: dayjs(inbox.data.generatedAt).format("HH:mm:ss") })}
              </Text>
            )}
            <Button
              variant="default"
              leftSection={<IconRefresh size={16} />}
              loading={inbox.isFetching}
              onClick={() => inbox.refetch()}
            >
              {t("common.refresh")}
            </Button>
          </Group>
        }
      />
      {inbox.error && <QueryError error={inbox.error} onRetry={inbox.refetch} />}
      {inbox.isLoading ? <Skeleton h={400} /> : inbox.data && <InboxList sections={inbox.data.sections} />}
    </>
  );
}
